"use strict";
const negateExpression = require('./negateExpression');
const { STARTS_WITH, NOT_STARTS_WITH } = require('../definitions/operators');
module.exports = negateExpression(STARTS_WITH, NOT_STARTS_WITH);
//# sourceMappingURL=notStartsWithExpression.js.map